import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useCompany } from "../../../context/CompanyContext";
import { getArOpenItems } from "../../../Services/subledgerService";
import "./subledger.css";

const money = (n) =>
  Number(n || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export default function ARCustomerDetail() {
  const { companyId } = useCompany();
  const { customerId } = useParams();
  const nav = useNavigate();

  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!companyId || !customerId) return;
    (async () => {
      setLoading(true);
      try {
        const data = await getArOpenItems(companyId, customerId);
        setItems(data);
      } catch (e) {
        console.error(e);
        alert(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [companyId, customerId]);

  return (
    <div className="sl-shell">
      <div className="sl-row">
        <div>
          <h2 className="sl-title">Customer AR</h2>
          <p className="sl-sub">
            Open items are allocation-aware but derived from journal control
            postings.
          </p>
        </div>
        <div className="sl-row" style={{ justifyContent: "flex-end" }}>
          <button className="sl-btn" onClick={() => nav(-1)}>
            Back
          </button>
          <button
            className="sl-btn sl-btnPrimary"
            onClick={() => nav("/ar/allocations")}
          >
            Allocate Payments
          </button>
        </div>
      </div>

      <div className="sl-card" style={{ marginTop: 12 }}>
        <div className="sl-tableWrap">
          <table className="sl-table">
            <thead>
              <tr>
                <th>Doc Type</th>
                <th>Doc Ref</th>
                <th>Posting</th>
                <th>Due</th>
                <th className="num">Original</th>
                <th className="num">Allocated</th>
                <th className="num">Open</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={7} style={{ opacity: 0.7 }}>
                    Loading…
                  </td>
                </tr>
              ) : items.length ? (
                items.map((it) => (
                  <tr key={it.anchor_journal_entry_id}>
                    <td>{it.source_type}</td>
                    <td style={{ opacity: 0.85 }}>
                      {String(it.source_id).slice(0, 8).toUpperCase()}
                    </td>
                    <td>{it.posting_date || "—"}</td>
                    <td>{it.due_date || "—"}</td>
                    <td className="num">₦{money(it.original_amount)}</td>
                    <td className="num">₦{money(it.allocated_amount)}</td>
                    <td className="num">
                      <strong>₦{money(it.open_amount)}</strong>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="sl-empty">
                    <strong>No open items</strong>
                    Either fully settled or journals not posted to A/R control
                    with customer dimension.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div style={{ marginTop: 10, opacity: 0.7, fontSize: 12 }}>
          Tip: “View underlying journal” will be wired once you share your
          journal viewer route/component.
        </div>
      </div>
    </div>
  );
}
